import Axios from '@/components/api/axios.js'

/**********************************************************************************
 * 虚拟变量
 **********************************************************************************/
export default {
	/**
	 * 获取变量树
	 * @param String deviceno
	 * @param {Object} callback
	 */
	getVariableTree: (deviceNo, success, failure) => {
		Axios.post('/variable/getVariableTree.do',{
			deviceNo
		}, success, failure)
	},
	/**
	 * 获取多个变量数
	 * @param String deviceNoList
	 * @param success
	 * @param failure
	 */
	getVariableTreeByNoList: (deviceNoList,success,failure) => {
		Axios.post('/variable/getVariableTreeByNoList.do',{
			deviceNoList
		}, success, failure)
	},
	searchApptypeTree: (success, failure) => {
		Axios.post('/variable/searchApptypeTree.do', {}, success, failure)
	},
	/**
	 * 查询指定变量类型的可查看设备变量树
	 */
	getVariableTreeFilterByAppTypeNos: (appTypeNos,success, failure) => {
		Axios.post('/variable/getVariableTreeFilterByAppTypeNos.do', {appTypeNos}, success, failure)
	},
	/**
	 * 通过通讯变量名查询对应的通讯变量信息
	 */
	getVariableByVariableNameList: (variableNameList,success, failure) => {
		Axios.post('/variable/getVariableByVariableNameList.do', {variableNameList}, success, failure)
	},
	/**
	 * 获取虚拟设备变量列表
	 * deviceNo  设备no
	 */
	getVariableList: (deviceNo, success, failure) => {
		Axios.post('/variable/getVariableList.do', {
			deviceNo
		}, success, failure)
	},
}
